export default function AIResponseStats({ stats }) {
  if (!stats) return null;

  const { costEstimate, total_tokens, input_tokens, output_tokens, thoughts_tokens, modelName, elapsedMs } = stats;

  const seconds = elapsedMs != null ? (elapsedMs / 1000).toFixed(1) : null;
  const cost = costEstimate != null && !isNaN(costEstimate) ? `$${costEstimate.toFixed(4)}` : null;

  return (
    <div className='d-flex flex-wrap align-items-center gap-2 text-muted small mt-1 px-2 py-1 bg-white border rounded'
      style={{ fontSize: '0.78em', gap: '0.45rem' }}>
      {modelName && <span className='badge badge-secondary font-weight-normal'>{modelName}</span>}
      {seconds && <span title='Elapsed time'>{seconds}s</span>}
      {cost && <span title='Estimated cost' className='text-danger'>{cost}</span>}
      {total_tokens != null && <span title='Total tokens'>{total_tokens.toLocaleString()} tok</span>}
      {input_tokens != null && <span className='text-info' title='Input tokens'>↑{input_tokens.toLocaleString()}</span>}
      {output_tokens != null && <span className='text-success' title='Output tokens'>↓{output_tokens.toLocaleString()}</span>}
      {thoughts_tokens > 0 && <span className='text-warning' title='Thinking tokens'>💭{thoughts_tokens.toLocaleString()}</span>}
    </div>
  );
}
